import React, { useEffect, useState, useRef } from "react";
import { config } from "../../../../../../../config";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { Link, useParams, withRouter, useHistory } from "react-router-dom";
import CustomSelect from "../../../../../../../Util/CustomSelect/CustomSelect";
import back from "../../../../../../../assets/arrow-back.svg";
import {
  TAGS,
  OLD_TAGS,
  // TEMPLATE_STATUS,
  TEMPLATE_TEXT_LENGTH,
  SCHEDULE_TYPE,
  PLAYER_TYPE,
  SETTING_TYPE
} from "../../../../../../../Util/helper";
import { messages } from "../../../../../../../messages";
import "./Template.css";
import Timepicker from "../../../../../../../Util/Timepicker/Timepicker";
import plusSvg from "../../../../../../../assets/plus-icon.svg";
import minusSvg from "../../../../../../../assets/minus-pri.png";

function AddTemplate() {
  const templateId = useParams().id;
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    body: "",
  });
  const history = useHistory();
  const [errors, setErrors] = useState({ name: "", body: "", status: "" });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [charCounter, setCharCounter] = useState(TEMPLATE_TEXT_LENGTH);
  const [daysData, setDaysData] = useState([]);
  const [hoursData, setHoursData] = useState([]);

  useEffect(() => {
    setDaysData(() => {
      const data = [];
      for (let i = 0; i <= 30; i++) {
        data.push({ title: i > 0 ? `${i} day before match` : `Match day`, value: i });
      }
      return data;
    });
    setHoursData(() => {
      const data = [];
      for (let i = 0; i < 15; i++) {
        data.push({ title: `${i + 1} hours before match`, value: i + 1 });
      }
      return data;
    });
  }, []);
  const handleFormChange = (e, name) => {
    e.preventDefault();
    if (e.target.name === "body") {
      setCharCounter(TEMPLATE_TEXT_LENGTH - (e.target.value || "").length);
    }
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  let focusBody = useRef();
  function handleValidation() {
    let errArray = {
      settings: {}
    };
    let formIsValid = true;
    if (!formData.name?.trim()) {
      formIsValid = false;
      errArray["name"] = messages && messages.emptyTemplateName;
    }
    if (!formData.body?.trim()) {
      formIsValid = false;
      errArray["body"] = messages && messages.emptyTemplateBody;
    }
    if (!formData.type) {
      formIsValid = false;
      errArray["status"] = messages && messages.emptyTemplateStatus;
    }

    if (SETTING_TYPE.includes(formData.type)) {
      if (!formData.reminder_user_type?.trim()) {
        formIsValid = false;
        errArray["reminder_user_type"] = messages && messages.selectSendTo;
      }

      if (formData?.settings?.length) {
        formData.settings?.forEach((settings, key) => {
          if (!errArray.settings[key]) {
            errArray.settings[key] = {};
          }
          console.log('settings["day"]', settings["day"]);
          if (settings["day"] < 0 || settings["day"] === undefined) {
            formIsValid = false;
            errArray.settings[key]['day'] = messages && messages.dayIsRequired;
          }
          if (settings["day"] === 0 && !settings["schedule_type"]) {
            formIsValid = false;
            errArray.settings[key]['schedule_type'] = messages && messages.scheduleTypeIsRequired;
          }
          if ((settings.day === 0 && settings.schedule_type === 'fixed' || settings.day !== 0) && !settings["time"]) {
            formIsValid = false;
            errArray.settings[key]['time'] = messages && messages.timeIsRequired;
          }
    
          if (settings.day === 0 && settings.schedule_type === 'variable' && !settings["hour"]) {
            formIsValid = false;
            errArray.settings[key]['hour'] = messages && messages.hoursBeforeIsRequired;
          }
    
        });
      }
    }
    
    
    setErrors(errArray);
    return formIsValid;
  }

  useEffect(() => {
    handleValidation();
    // eslint-disable-next-line
  }, [formData.name, formData.body, formData.type, formData.settings]);

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (handleValidation()) {
      const temp = { ...formData };
      temp.settings = JSON.stringify(temp.settings);
      if (templateId) {
        axiosApi.put(`${config.apiUrl}/templates/${templateId}`, temp).then((res) => {
          if (res) {
            history.push(`/admin/settings/templates`);
          }
          setCharCounter(TEMPLATE_TEXT_LENGTH);
        });
      } else {
        axiosApi.post(`${config.apiUrl}/templates/create`, temp).then((res) => {
          if (res) {
            history.push(`/admin/settings/templates`);
          }
        });
      }
    }
  };

  useEffect(() => {
    if (templateId) {
      axiosApi.get(`${config.apiUrl}/templates/${templateId}`).then((res) => {
        if (res && res.data && res.data.data) {
          setFormData({
            name: res.data.data?.name,
            type: res.data.data?.type,
            body: res.data.data?.body,
            settings: res?.data?.data?.settings?.length ? JSON.parse(res?.data?.data?.settings) : [{}],
            reminder_user_type: res?.data?.data?.reminder_user_type || null,
          });
          setCharCounter(TEMPLATE_TEXT_LENGTH - (res.data.data?.body || "").length);
        }
      });
    }
    // eslint-disable-next-line
  }, []);

  const concatVar = (tag) => {
    const val = tag.tag;
    const startIdx = focusBody?.current?.selectionStart;
    const endIdx = focusBody?.current?.selectionEnd;
    let a = formData.body.substring(0, startIdx) + val + formData.body.substring(endIdx, formData.body.length);
    setFormData((prev) => ({
      ...prev,
      body: a,
    }));
    focusBody?.current?.focus();
    setTimeout(() => {
      focusBody.current.selectionStart = focusBody.current.selectionEnd = (startIdx === endIdx ? endIdx : startIdx) + (val || "").length;
    });
  };

  const onSelectDayBefore = (event) => {
    setFormData((prevPayload) => {
      if (prevPayload.settings[event.key]) {
        prevPayload.settings[event.key][event.field] = event.data;
        if (event.field === "day") {
          prevPayload.settings[event.key]["schedule_type"] = event.data === 0 ? "variable" : "fixed";
        } else if (event.field === "schedule_type") {
          const field = event.data === "variable" ? "time" : "hour";
          delete prevPayload.settings[event.key][field];
        }
      }
      return { ...prevPayload, settings: prevPayload.settings };
    });
  };

  const addReminder = () => {
    setFormData((prev) => ({ ...prev, settings: [...prev.settings, {}] }));
  };

  const removeReminder = (key) => {
    setFormData((prev) => {
      if (prev.settings[key]) {
        prev.settings.splice(key, 1);
      }
      return { ...prev, settings: prev.settings };
    });
  };

  const onChange = (resp) => {
    if (resp) {
      setFormData((prevData) => ({
        ...prevData,
        [resp.type]: resp.data,
      }));
    }
  };
  return (
    <>
      <div className='content-wrapper add-template-wrapper'>
        <div className='header'>
          <Link
            to={{
              pathname: "/admin/settings/templates",
            }}
          >
            <button className='btn back-btn'>
              <img src={back} alt='' />
              Back to Templates
            </button>
          </Link>
          <div class='header-blk'>
            <h2>{templateId ? "Edit Template" : "Add Template"}</h2>
            <p>Default SMS templates for leagues.</p>
          </div>
        </div>
        <div className='inner-wrapper edit-template'>
          {/* <div className="flex-blk template-name-field">
            <label>Name</label><br />
            <input type="text" name="name" value={formData?.name} onChange={(e, name) => handleFormChange(e, name)} id="search_bar" />
            <span className="error">{formSubmitted && errors['name']}</span>
          </div> */}
          {/* <div className="flex-blk template-name-field">
            <CustomSelect
              label={'Type'}
              data={[
                {
                  id: 'reminder',
                  title: 'Reminder'
                },
                {
                  id: 'follow_up',
                  title: 'Follow Up'
                }
              ]}
              placeholder={templateId ? TEMPLATE_STATUS[formData?.type] : 'Select Status'}
              type={'status'}
              onSelect={(ele) => ele && setFormData(prev => ({ ...prev, type: ele.id }))}
              selector="title"
            />
            <span className="error">{formSubmitted && errors['status']}</span>
          </div> */}
          { 
            SETTING_TYPE.includes(formData.type) && 
            <div className="addLeague-wrapper edit-template">
              <div className="top-blk ls-top-blk">
                <div className="setting-section">
                  <div className="input-blk">
                    <div className='input-wrapper send-to'>
                      <CustomSelect
                        required={true}
                        uniqueKey={"send-to"}
                        data={[
                          {
                            id: "all",
                            title: "All Players",
                          },
                          {
                            id: "captain",
                            title: "Captains",
                          },
                        ]}
                        label={"Send To"}
                        placeholder={formData.reminder_user_type ? PLAYER_TYPE[formData.reminder_user_type] : "Select Player Type"}
                        type={"hosted_by"}
                        onSelect={(e) => onChange({ type: "reminder_user_type", data: e?.id || formData.reminder_user_type })}
                        selector='title'
                      />
                      <span className="error p-abs">{formSubmitted && errors?.reminder_user_type}</span>
                    </div>
                    <div className='multi-blk'>
                      {formData?.settings?.length &&
                        formData.settings?.map((val, key) => (
                          <div className='input-group' key={key}>
                            <div className='input-wrapper'>
                              <CustomSelect
                                required={true}
                                uniqueKey={"playoff-day-section"}
                                data={daysData}
                                label={"Day"}
                                placeholder={val.day !== undefined ? daysData[val.day]?.title : "Select Day"}
                                type={"hosted_by"}
                                onSelect={(e) => {
                                  e && onSelectDayBefore({ field: "day", data: e?.value, key });
                                }}
                                selector='title'
                              />
                              <span className='error'>{formSubmitted && errors?.settings?.[key]?.["day"]}</span>
                            </div>
                            {val.day === 0 && (
                              <div className='input-wrapper'>
                                <CustomSelect
                                  required={true}
                                  uniqueKey={"playoff-schedule-type"}
                                  data={[
                                    {
                                      title: "Fixed Time",
                                      value: "fixed",
                                    },
                                    {
                                      title: "Relative hour(s)",
                                      value: "variable",
                                    },
                                  ]}
                                  label={"Schedule Type"}
                                  placeholder={val.schedule_type !== undefined ? SCHEDULE_TYPE[val.schedule_type] : "Select Schedule Type"}
                                  type={"hosted_by"}
                                  onSelect={(e) => e && onSelectDayBefore({ field: "schedule_type", data: e?.value || val?.schedule_type, key })}
                                  selector='title'
                                />
                                <span className='error'>{formSubmitted && errors?.settings?.[key]?.["schedule_type"]}</span>
                              </div>
                            )}

                            {val.day === 0 && val.schedule_type === "variable" && (
                              <div className='input-wrapper'>
                                <CustomSelect required={true} uniqueKey={"playoff-hour-selection"} data={hoursData} label={"Hour"} placeholder={val.hour !== undefined ? hoursData[val.hour - 1]?.title : "Select Hour"} type={"hosted_by"} onSelect={(e) => e && onSelectDayBefore({ field: "hour", data: e?.value, key })} selector='title' />
                                <span className='error'>{formSubmitted && errors?.settings?.[key]?.["hour"]}</span>
                              </div>
                            )}
                            {((val.day === 0 && val.schedule_type === "fixed") || val.day !== 0) && (
                              <div className='input-field'>
                                <Timepicker required={true} time={val.time} callback={(e) => e && onSelectDayBefore({ field: "time", data: e, key })} />
                                <span className='error'>{formSubmitted && errors?.settings?.[key]?.["time"]}</span>
                              </div>
                            )}

                            <div className='action-btn'>
                              {formData?.settings?.length - 1 === key && (
                                <button onClick={() => addReminder()}>
                                  <img src={plusSvg} alt='add' />
                                </button>
                              )}
                              {formData?.settings?.length > 1 && (
                                <button onClick={() => removeReminder(key)}>
                                  <img src={minusSvg} alt='remove' />
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          }
          <div className='message-field'>
            {/* <label>Message Detail</label> */}
            
            <textarea ref={focusBody} name='body' maxLength={TEMPLATE_TEXT_LENGTH} value={formData?.body} onChange={(e, name) => handleFormChange(e, name)}></textarea>
            <span className='error'>{formSubmitted && errors["body"]}</span>
            <span className='remain-text'>Character limit per message: 150 </span>
          </div>
          
          <div className="ls-top-blk">
            <div className="setting-section">
              <div className='tags'>
                  {/* <button type='button' onClick={() => concatVar('{first_name}')}>First Name</button>
                  <button type='button' onClick={() => concatVar('{last_name}')}>Last Name</button>
                  <button type='button' onClick={() => concatVar('{date}')}>Date</button>
                  <button type='button' onClick={() => concatVar('{time}')}>Time</button>
                  <button type='button' onClick={() => concatVar('{location}')}>Location</button> */}

                  {TAGS.map((x, i) => ( ((OLD_TAGS.includes(x.label) && ['regular_reschedule_message_template', 'playoff_reschedule_message_template'].includes(formData?.type) ) || !OLD_TAGS.includes(x.label)) && 
                    <span
                      key={i}
                      onClick={() => {
                        concatVar(x);
                      }}
                    >
                      {x.label}
                    </span>
                  ))}
                </div>
            </div>    
          </div>
              
          <div className='flex-blk'>
            <button type='button' onClick={() => handleSubmit()} className='btn'>
              Save Template
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export default withRouter(AddTemplate);
